<div fxLayoutAlign="center start" fxLayout="row wrap">
  <mat-icon>error</mat-icon>
  <h1 fxFlex="100%">Something went wrong! <br /><span>◕︵◕</span></h1>
  <p fxFlex="100%">Please try again.</p>
</div>
